import { render, staticRenderFns } from "./node-front-news.vue?vue&type=template&id=0313d89c&scoped=true"
import script from "./node-front-news.vue?vue&type=script&lang=js"
export * from "./node-front-news.vue?vue&type=script&lang=js"
import style0 from "./node-front-news.vue?vue&type=style&index=0&id=0313d89c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0313d89c",
  null
  
)

export default component.exports